// screenMixin.js
export default {
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    isSmallScreen() {
      return this.windowWidth < 992;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
};